import { ChangeDetectionStrategy, Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SessionService } from 'src/utilities/session/session.service';
import { LoaderService } from './loader.service';
import { delay, Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'client';

  constructor(
    public sessionService: SessionService, 
    private router: Router, 
    public loaderService: LoaderService
  ) { }

  ngOnInit() {
    // El resolver se encarga de todo
  }

  ngOnDestroy(): void {
  }
}
